import { jsx } from "react/jsx-runtime";
import React from "react";
var warning_triangle_orange_small_default = (prefix = "") => {
  return [
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "m1.0154 15.457 7.336-13.9228h1.3041l7.3599 13.9291-.6598 1.0709H1.6671l-.6517-1.0772z",
        fill: "rgb(var(--colour-semantic-caution, 242, 106, 47))"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M10.2485 13.25c0 .6904-.5597 1.25-1.25 1.25-.6904 0-1.25-.5596-1.25-1.25S8.308 12 8.9985 12c.6903 0 1.25.5596 1.25 1.25z",
        fill: "rgb(var(--colour-text-and-icon-5, 255, 255, 255))"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8 10.5V6h2v4.5H8z",
        fill: "rgb(var(--colour-text-and-icon-5, 255, 255, 255))"
      }
    )
  ];
};
export {
  warning_triangle_orange_small_default as default
};
